const getPageType = (path) => {
  const page = path.split('/')[1];

  if (page === 'collection') {
    return 'COLLECTION';
  }

  if (page === 'p') {
    return 'PIP';
  }

  return '';
};

export const buildServicesLink = ({ itemId, leadGenUrl, path } = {}) => {
  return `${leadGenUrl}/form?vfrom=iframe-lead&internet_id=${itemId}&pageType=${getPageType(path)}#`;
};

export const buildSamLink = (modelNumber) => (
  `https://services.homedepot.com/sam/flooring-measure/?modelNumber=${modelNumber}&leadSource=PIP_CARPET_SAMPLES`
);
